<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <div style=" display: flex">
<!--          <el-button type="primary" plain @click="refresh">刷新</el-button>-->
          <el-button type="primary" plain @click="refresh">刷新</el-button>
          <el-button type="primary" plain @click="add" style=" position: relative ;margin-left: 30px" v-show="show === '0'">
            新建工单
          </el-button>
          <el-input v-model="inputOrderNo" style="width: 20%;position: relative;margin-left: 30px"
                    placeholder="输入工单号查询"
                    clearable></el-input>
          <!--          <el-button type="primary" @click="searchByOrderNo">查询</el-button>-->
          <el-input v-model="search" style="width: 20%;position: relative; margin-left: 30px" maxlength="50"
                    show-word-limit
                    placeholder="输入使用单位"
                    clearable>
          </el-input>
          <!--          <el-button type="primary" @click="qSearch">查询</el-button>-->
          <el-date-picker
              v-model="createDateSearch"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="width: 250px;left: auto; margin-left: 30px"
          >
          </el-date-picker>
          <el-button type="primary" plain @click="searchByCreateDate">查询</el-button>
        </div>
      </el-header>
      <!--表格展示-->
      <el-main>
        <el-table
            :data="tableData"
            style="width: 100%;height: 50vh"
            border
            stripe
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" min-width="30" max-width="60" v-if="show === '1'"/>
          <!--          <el-table-column label="orderId" prop="orderId"/>-->
          <el-table-column label="工单号" min-width="130" max-width="200" prop="orderNo"/>
          <el-table-column label="电梯号" min-width="60" max-width="120" prop="liftId"/>
<!--          <el-table-column label="安装地址" prop="detailArea"/>-->
          <el-table-column label="产品编号" min-width="88" max-width="120"   prop="liftNum"/>
          <el-table-column label="使用单位" min-width="188" max-width="200" prop="unit"/>
<!--          <el-table-column label="使用单位代码" prop="unitCode"/>-->
<!--          <el-table-column label="单位内编码" prop="unitNum"/>-->
          <el-table-column label="设备品种" prop="liftType"/>
          <el-table-column label="创建时间" min-width="140" max-width="200" prop="createDate" sortable>
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.createDate, "yyyy-MM-dd hh:mm:ss") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="检测员" prop="userAlias"/>
          <el-table-column label="操作" min-width="70" max-width="120" fixed="right">
            <template #default="scope">
              <el-button type="danger" plain  size="small" style="margin-left: 3px;"
                         @click="deleteOne(scope.row.orderId)" v-show="show === '0'">删除
              </el-button>
              <el-button type="primary" plain size="small" style="margin-left: 3px;"
                         @click="allocation(scope.row)" v-show="show === '1'">分配
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-button
          style="width: 96px ;height:24px;position: relative ;left: 90%;font-weight: bold"
          type="info" plain
          @click="allocationInBatch()"
          v-show="show === '1'"
      >批量分配工单
      </el-button
      >
      <!--        分页-->
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[10, 20]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </el-footer>

    </el-container>
    <!--    新建工单弹窗 -->
    <el-dialog v-model="dialogFormVisible" title="创建工单" :lock-scroll="false"
               draggable :fullscreen="true" :before-close="canCelRacharge">
      <el-form :model="form" ref="form" :rules="rules" status-icon label-width="160px">
        <el-container>
          <el-aside width="450px" style="margin-top: 20px">
            <el-text>
              请点击选择区域
            </el-text>
            <el-tree :data="treeData"
                     :props="defaulareaIdtProps"
                     node-key=""
                     ref="tree"
                     highlight-current
                     :default-expanded-keys="treeData"
                     :expand-on-click-node="false"
                     @node-click="handleNodeClick">
              <template #default="{ node }">
                        <span class="custom-tree-node">
                          <span>{{ node.data.areaName }}</span>
                          <span class="custom-tree-node-areaName">
                          </span></span></template>
            </el-tree>
          </el-aside>

          <el-main v-show="show1" style="height: 50%;margin-top: 40px">
            <el-table
                ref="select"
                :data="tableDataAdd"
                style="width: 100%"
                border
                @selection-change="(data) => {
                  toggleRowArr = data
                }"
                :row-class-name="tableRowClassName1"
                :row-key="getRowLiftId"
            >
              <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
              <el-table-column label="电梯号" prop="liftId"/>
              <el-table-column label="使用单位" prop="unit"/>
              <el-table-column label="设备品种" prop="liftType"/>
              <el-table-column label="型号" prop="liftModel"/>
              <el-table-column label="产品编号" prop="liftNum"/>
              <el-table-column label="维护保养单位" prop="maintenance"/>
            </el-table>
            <!--        分页-->
            <el-footer>
              <div class="demonstration" style="margin: 10px 0">
                <el-pagination v-model:currentPage="currentPage1"
                               v-model:page-size="pageSize1"
                               :page-sizes="[10, 20]"
                               :small="small1"
                               :background="background1"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total1"
                               :prev="prev1"
                               :pager="pager1"
                               :next="next1"
                               :jumper="jumper1"
                               @size-change="handleSizeChange1"
                               @current-change="handleCurrentChange1"></el-pagination>
              </div>
            </el-footer>
          </el-main>


        </el-container>
      </el-form>

      <template #footer>
                      <span class="dialog-footer">
                        <el-button @click="canCelRacharge">关闭</el-button>
                        <el-button type="primary" @click="save('form')" :disabled="saveIs"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>
    <!--    分配工单弹窗-->
    <el-dialog v-model="allocationDialog" title="分配工单" :lock-scroll="false"
               draggable :close-on-click-modal="false"
               :close-on-press-escape="false" :before-close="closeAllocation">
      <el-form :model="allocationForm" ref="form" status-icon label-width="160px">
        <el-select v-model="selectUserName" clearable multiple placeholder="请选择用户" @click="userNameByLiftId()">
          <div>
            <text font-style="normal" style="color: red">主检为第一个，副检为第二个</text>
          </div>
          <el-option
              v-for="(item,index ) in options"
              :key="item.userId"
              :label="item.userAlias"
              :value="index">
          </el-option>
        </el-select>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
                        <el-button @click="closeAllocation">关闭</el-button>
                        <el-button type="primary" @click="update()"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>
    <!--    批量分配工单弹窗-->
    <el-dialog v-model="allocationDialogInBatch" title="批量分配工单" :lock-scroll="false"
               draggable :close-on-click-modal="false"
               :close-on-press-escape="false" :before-close="closeBatch">
      <el-form :model="allocationInbatchForm" ref="form" status-icon label-width="160px">
        <el-container>
          <el-aside width="350px" style="margin-top: 20px">
            <el-text>
              请点击选择区域
            </el-text>

            <el-tree :data="treeData"
                     :props="defaulareaIdtProps"
                     node-key="areaLevel"
                     ref="tree"
                     highlight-current
                     :default-expanded-keys="treeData"
                     :expand-on-click-node="false"
                     @node-click="handleNodeClickInbatch">
              <template #default="{ node }">
                        <span class="custom-tree-node">
                          <span>{{ node.data.areaName }}</span>
                          <span class="custom-tree-node-areaName">
                          </span></span></template>
            </el-tree>
          </el-aside>

          <el-main v-show="show2" style="height: 25%;margin-top: 20px">
            <div>
              <text font-style="normal" style="color: red">主检为第一个，副检为第二个</text>
            </div>
            <el-table
                ref="selectUserId"
                :data="tableDataAdd"
                style="width: 100%;height: 50vh"
                border
                @selection-change="(data) => {
                  toggleRowArr = data
                }"
                :row-class-name="tableRowClassName1"
                :row-key="getRowUserId"
            >
              <el-table-column type="selection" :reserve-selection="true"/>
              <el-table-column label="检测员" prop="userAlias"/>
            </el-table>
            <!--        分页-->
            <el-footer>
              <div class="demonstration" style="margin: 10px 0">
                <el-pagination v-model:currentPage="currentPage1"
                               v-model:page-size="pageSize1"
                               :page-sizes="[10, 20]"
                               :small="small1"
                               :background="background1"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total1"
                               :prev="prev1"
                               :pager="pager1"
                               :next="next1"
                               :jumper="jumper1"
                               @size-change="handleSizeChange1"
                               @current-change="handleCurrentChange1"></el-pagination>
              </div>
            </el-footer>
          </el-main>

        </el-container>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
                        <el-button style="margin-top: -40px"
                                   @click="closeBatch">关闭</el-button>
                        <el-button style="margin-top: -40px" type="primary" @click="getOrderAll()"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>

  </div>
</template>

<style>

</style>

<script>
import request from "@/util/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Order',
  data() {
    const treeData = [];
    return {
      show2: false,
      show1: false,
      show: this.$route.query.show,
      currentPage: 1,
      pageSize: 10,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      saveIs: false,//点击了添加
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [], //未分页的数据
      currentPage1: 1,
      pageSize1: 10,
      total1: 10,
      small1: "small",
      background1: "background",
      prev1: this.currentPage1 - 1,
      pager1: this.currentPage1,
      next1: this.currentPage1 + 1,
      jumper1: this.currentPage1,
      ticket1: [], //未分页的数据
      tableData: [], //已分页的数据
      reload: 0,//判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",//判断是否已经点击了模糊查询
      form: {},//新建弹窗
      //分配弹窗
      allocationForm: {},
      //批量分配弹窗
      allocationInbatchForm: {},
      //批量分配弹窗弹窗表格
      allocationInBatchTableData: {},
      formEdit: {},//编辑
      selectUserName: [],//分配用户时选择用户弹窗
      allocationDialog: false,  //分配弹窗
      dialogFormVisible: false, //新建弹窗
      allocationDialogInBatch: false, //批量分配弹窗
      //批量分配 远程搜索
      loading: false,
      //批量分配 远程搜索
      list: [],
      search: '',
      //输入工单号
      inputOrderNo: '',
      createDateSearch: '',
      areaSearch: '',//新建工单地区查询
      userNameSearch: '',//分配工单用户查询
      orderId: '',
      createBy: '',
      shareSign: '',
      roleId: '',
      areaId: '',
      liftId: '',
      userId: '',
      userAlias: '',
      userName: '',
      multipleSelection: [],
      options: [],
      sessions: {},
      props: {multiple: true},
      count: 1,
      liftOptions: [],
      areaData: [],
      defaultProps: {  //树 区域
        children: 'parent',
        label: 'label'
      },
      //树第五级节点 点击弹出表格
      tableDataAdd: [],
      // defaulareaIdtProps: {
      //   children: 'parent',
      // },
      toggleRowArr: [],
      //树节点下表格所有数据
      tableAllData: [],
      treeData: JSON.parse(JSON.stringify(treeData)),
      filterText: '',  //树文本查询
      // 新建工单 输入工单号
      orderNo: '',
      zhonzhuan: '',
      rules: {
        orderNo: [{required: true, message: '请输入创建的工单号', trigger: 'blur'}],
      },
      //分页多选切换页面保留之前的选中
    }
  },
  created() {
    this.load()
  },
  //树查询
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    closeBatch() {//关闭弹窗
      this.$refs.selectUserId.clearSelection();
      this.allocationDialogInBatch = false;
      this.show2 = false
    },
    closeAllocation() {//关闭弹窗
      this.allocationDialog = false;
      this.selectUserName = []
    },
    //点击关闭新增弹窗后清除数据
    canCelRacharge() {
      this.$refs.select.clearSelection();
      this.dialogFormVisible = false
      this.$refs.form.resetFields()
      this.show1 = false
      this.form = {};
      this.toggleRowArr = [];
    },
    //区域树查询所属用户
    handleNodeClickInbatch(data) {
      if (data.areaLevel === 3) {//data.areaLevel === 5
        this.show2 = true
        this.areaId = data.areaId
        request.get('/order/getUserName', {
          params: {
            areaId: this.areaId
          }
        }).then(res => {
          // this.tableDataAdd = res.data
           this.tableAllData = res.data
          this.ticket1 = res.data;
          this.total1 = this.ticket1.length;
          this.getPageInfo1();
        })
      }
    },
    //区域树节点函数
    handleNodeClick(data) {
      if (data.areaLevel === 3) {//data.areaLevel === 5
        this.show1 = true
        this.areaId = data.areaId
        request.get('/order/getLiftId', {
          params: {
            areaId: this.areaId
          }
        }).then(res => {
          // this.tableDataAdd = res.data
          this.ticket1 = res.data;
          this.total1 = this.ticket1.length;
          this.getPageInfo1();
          // let arr = []
          // res.data.forEach(item => {
          //   arr.push({
          //     liftId: item
          //   })
          // })
          // this.tableDataAdd = arr;
        })
      }
    },
    //弹窗区域和电梯号查询
    // aSearch() {
    //   this.userName = sessionStorage.getItem('userName')
    //   request.get('/order/liftIdAndAreaName', {
    //     params: {
    //       userName: this.userName
    //     }
    //   }).then(res => {
    //   })
    // },
    //工单号查询
    searchByOrderNo() {
      if (this.inputOrderNo == null || this.inputOrderNo === "") {
        this.load()
      }
      this.createBy = sessionStorage.getItem('userName')
      request.get('/order/searchByOrderNo', {
        params: {
          createBy: this.createBy,
          orderNo: this.inputOrderNo
        }
      }).then(res => {
        this.ticket = res;
        this.total = this.ticket.length
        this.getPageInfo();
      })

    },
    //使用单位条件查询
    // qSearch() {
    //   if (this.search == null || this.search === "") {
    //     this.load()
    //   }
    //   this.createBy = sessionStorage.getItem('userName')
    //   request.get('/order/search', {
    //     params: {
    //       createBy: this.createBy,
    //       unit: this.search
    //     }
    //   }).then(res => {
    //     this.ticket = res;
    //     this.total = this.ticket.length
    //     this.getPageInfo();
    //   })
    // },
    //根据创建日期查询
    searchByCreateDate() {
      if (this.createDateSearch == null && this.inputOrderNo == null && this.search == null || (this.createDateSearch === "" && this.inputOrderNo === "" && this.search === "")) {
        this.load()
      } else {
        this.createBy = sessionStorage.getItem('userName')
        let map = {
          createBy: this.createBy,
          createDate: this.createDateSearch.toString(),
          unit: this.search,
          orderNo: this.inputOrderNo
        }
        request.post('/order/searchByInfo', map).then(res => {
          this.ticket = res;
          this.total = this.ticket.length
          this.getPageInfo();
        })
      }

      // if (this.createDateSearch == null || this.createDateSearch === "") {
      //   this.load()
      // }
      // this.createBy = sessionStorage.getItem('userName')
      // request.get('/order/createDate', {
      //   params: {
      //     createBy: this.createBy,
      //     createDate: this.formatDate(this.createDateSearch, "yyyy-MM-dd")
      //   }
      // }).then(res => {
      //   this.ticket = res;
      //   this.total = this.ticket.length
      //   this.getPageInfo();
      // })
    },
    //未分配查询按钮
    unReceive() {
      request.post('/order/unReceive').then(res => {
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo()
      })
    },
    //全选按钮   批量查询
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分配工单时用户名查询
    // option(row) {
    //   this.liftId = row.liftId
    //   request.get('/order/userNameByLiftId', {
    //     params: this.liftId
    //   }).then(res => {
    //     this.options = res.data
    //   })
    // },
    //登录用户管理区域电梯号查询
    async getListOptions() {
      if (this.liftOptions.length) {
        return false
      }
      this.userName = sessionStorage.getItem('userName')
      const {data} = await request.get('order/liftIdAndAreaName?userName=' + this.userName)
      // const {data} = await request.get('order/liftIdAndAreaName', {
      //   params: this.userName
      // })
      let arr = []
      let index = 1

      function fy(idx) {
        index++
        let currentArr = []
        if (index < 6) {
          let thisData = []
          if (index === 5) {
            thisData = data.liftId[idx]
          } else {
            thisData = data['areaName' + index][idx]
          }
          currentArr.push({
            value: thisData,
            label: thisData,
            children: fy(idx)
          })
        }
        return currentArr
      }

      data.areaName1.forEach((item, idx) => {
        index = 1
        arr.push({
          value: item,
          label: item,
          children: fy(idx)
        })
      })
      this.liftOptions = arr
    },
    //添加新建工单按钮点击事件
    add() {
      this.dialogFormVisible = true;
      this.form = {};
      this.userName = sessionStorage.getItem('userName')
      request.get('/order/list2', {
        params: {
          userName: this.userName
        }
      }).then(res => {
        this.treeData = res.data.structList;
      })
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return ""
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    //刷新按钮
    refresh() {
      this.load()
      this.inputOrderNo = ''
      this.search = ''
      this.createDateSearch = ''
      this.currentPage = 1
    },
    //页面初始化 只查询createBy=登录用户并且未进行检测的工单
    load() {
      this.createBy = sessionStorage.getItem('userName')
      request.get('/order/Query?createBy=' + this.createBy).then(res => {
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo()
      })
    },
    //保存新增数据
    save(formName) {
      console.log(formName)
      // this.$refs[formName].validate((valid) => {
      //   //valid是检验的结果,bool值 validator: validateSolution_Name,
      // if (valid) {
      if (this.toggleRowArr.length > 0) {
        let liftId = []
        this.toggleRowArr.forEach(item => {
          liftId.push(item.liftId)
        })
        // this.form.createDate = new Date()
        this.form.createBy = sessionStorage.getItem('userName')
        // this.form.createDate = this.formatDate(this.form.createDate, "yyyy-MM-dd hh:mm:ss")
        this.form.liftId = liftId
        this.saveIs = true;
        // this.form.liftId = this.form.liftId[4]
        request.post('/order/orderAdd', this.form).then(res => {
          if (res.code.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.saveIs = false;
            this.load();
            this.dialogFormVisible = false;
            this.form = {};
            this.toggleRowArr = [];
            this.$refs.select.clearSelection();
          } else {
            this.$message({
              message: res.data,
              type: "error"
            });
            this.saveIs = false;
            this.load();
            this.dialogFormVisible = false;
            this.form = {};
            this.toggleRowArr = [];
            this.$refs.select.clearSelection();
          }
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择电梯!'
        });
      }
      this.show1 = false
    },
    //分配确认按钮点击事件
    update() {
      if (this.selectUserName.length !== 2) {
        this.$message({
          type: 'warning',
          message: '请选择分配的两个检测员!'
        });
      } else {
        this.allocationDialog = false;
        let arr = [];
        let array = [];
        for (let i = 0; i < this.selectUserName.length; i++) {
          arr.push(this.options[this.selectUserName[i]].userAlias)
          array.push(this.options[this.selectUserName[i]].userName)
        }
        // this.allocationForm.userAlias = this.options[this.selectUserName].userAlias.toString()
        // this.allocationForm.userName = this.options[this.selectUserName].userName.toString()
        this.allocationForm.userAlias = arr.toString(),
            this.allocationForm.userName = array.toString(),
            request.get('/order/allocation', {
              params: {
                // userName: this.allocationForm.userName.toString(),
                // userAlias: this.allocationForm.userAlias.toString(),
                userName: this.allocationForm.userName,
                userAlias: this.allocationForm.userAlias,
                orderId: this.allocationForm.orderId
              }
            }).then(res => {
              if (res.code.code === 200) {
                this.$message({
                  type: 'success',
                  message: '分配成功!'
                });
              } else {
                this.$message({
                  type: 'info',
                  message: res.data
                });
              }
              this.load();
              this.allocationForm = {};
              this.selectUserName = [];
            })
      }
      this.selectUserName = []
    },
    //批量分配确认
    getOrderAll() {
      this.allocationDialogInBatch = true;
      if (this.toggleRowArr.length !== 2) {
        this.$message({
          type: 'warning',
          message: '请选择两个检测员!'
        });
      } else {
        let arr = [];
        let array = [];
        for (let i = 0; i < this.tableAllData.length; i++) {
          for (let j = 0; j < this.toggleRowArr.length; j++) {
            if (this.toggleRowArr[j].userId === this.tableAllData[i].userId) {
              arr.push(this.toggleRowArr[j].userAlias)
              array.push(this.toggleRowArr[j].userName)
            }
          }
        }
        this.allocationInbatchForm.userAlias = arr.toString()
        this.allocationInbatchForm.userName = array.toString()
        let orderIdList = []
        this.multipleSelection.forEach(item => {
          item.userAlias = this.allocationInbatchForm.userAlias
          orderIdList.push(item.orderId)
        })
        // this.allocationInbatchForm.userName = userName
        request.post('/order/allocationInBatch', {
          userName: this.allocationInbatchForm.userName,
          userAlias: this.allocationInbatchForm.userAlias,
          ids: orderIdList
        }).then(res => {
          if (res.code.code === 200) {
            this.$message({
              type: 'success',
              message: '批量分配成功!'
            });
            this.$refs.selectUserId.clearSelection();
          } else {
            this.$message({
              type: 'info',
              message: '批量分配失败'
            });
          }
          this.$refs.selectUserId.clearSelection();
          this.allocationDialogInBatch = false;
          this.load();
        })
      }
      this.show2 = false
    },
    //分配工单按钮
    allocation(row) {
      this.allocationDialog = true;
      this.allocationForm = JSON.parse(JSON.stringify(row));
    },
    //分配工单弹窗 点击选择框 显示该该电梯区域下的用户名
    userNameByLiftId() {
      request.get('/order/userNameByLiftId', {
        params: {liftId: this.allocationForm.liftId}
      }).then(res => {
        this.options = res.data
      })
    },
    //批量分配工单
    allocationInBatch() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          type: 'warning',
          message: '请勾选再操作!'
        });
      } else {
        this.allocationDialogInBatch = true;
        //根据userName登录名查出区域
        this.userName = sessionStorage.getItem('userName')
        request.get('/order/list2', {
          params: {
            userName: this.userName
          }
        }).then(res => {
          this.treeData = res.data.structList;
        })
      }
    },
    //删除按钮点击事件
    deleteOne(orderId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.get('/order/orderDelete', {
          params: {orderId: orderId}
        }).then(res => {
          if (res.code.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo()
    },
    //新建工单电梯表格分页
    getPageInfo1() {
      //清空pageTicket中的数据
      this.tableDataAdd = [];
      // 获取当前页的数据
      for (let i = (this.currentPage1 - 1) * this.pageSize1; i < this.total1; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableDataAdd.push(this.ticket1[i]);
        //判断是否达到一页的要求
        if (this.tableDataAdd.length === this.pageSize1) break;
      }
    },
    handleSizeChange1(pageSize) {
      //修改当前每页的数据行数
      this.pageSize1 = pageSize;
      //数据重新分页
      this.getPageInfo1();
    },
    handleCurrentChange1(pageNum) {
      //修改当前的页码
      this.currentPage1 = pageNum;
      //数据重新分页
      this.getPageInfo1()
    },

    tableRowClassName({rowIndex}) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    },
    tableRowClassName1({rowIndex}) {
      for (var i = 0; i < this.tableDataAdd.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    },
    getRowLiftId(row) {
      return row.liftId
    },
    getRowUserId(row) {
      return row.userId
    },
  }
};
</script>